import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: row;
    justify-content: end;
`;


// WEBPACK FOOTER //
// ./src/SharedComponents/ButtonContainer.tsx